import { render } from "./Api.vue?vue&type=template&id=766dd3a8"
import script from "./Api.vue?vue&type=script&lang=js"
export * from "./Api.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__